<nav class="bg-white shadow-sm fixed w-full z-50 top-0 left-0 border-b border-gray-100 h-20 flex items-center">
  <div class="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center">

    <div class="flex-shrink-0">
      <img class="h-12 w-auto" src="/logo_rms.png" alt="RMS Logo"> </div>

    <div class="hidden md:flex space-x-8 text-sm font-bold text-gray-500 uppercase tracking-wide">
      <a href="#inicio" class="hover:text-blue-900 transition-colors">Inicio</a>
      <a href="#nosotros" class="hover:text-blue-900 transition-colors">Nosotros</a>
      <a href="#servicios" class="hover:text-blue-900 transition-colors">Servicios</a>
      <a href="#clientes" class="hover:text-blue-900 transition-colors">Clientes</a>
      <a href="#contacto" class="hover:text-blue-900 transition-colors">Contacto</a>
    </div>

    <div>
      <a routerLink="/login" class="bg-[#1e3a8a] hover:bg-blue-800 text-white px-6 py-2 rounded-md text-sm font-bold shadow-md transition-all cursor-pointer">
        Portal RMS
      </a>
    </div>
  </div>
</nav>

<div class="pt-20"></div>

<section id="inicio" class="relative bg-gray-900 h-screen flex items-center justify-center overflow-hidden">
  <div class="absolute inset-0 z-0">
    <div class="absolute inset-0 bg-cover bg-center animate-fade-carousel carousel-1"
         style="background-image: url('/img_home/Energia1.jpeg');"></div>

    <div class="absolute inset-0 bg-cover bg-center animate-fade-carousel carousel-2"
         style="background-image: url('/img_home/Energia2.jpg');"></div>

    <div class="absolute inset-0 bg-cover bg-center animate-fade-carousel carousel-3"
         style="background-image: url('/img_home/Telecominicaciones.JPG');"></div>

    <div class="absolute inset-0 bg-[#1e3a8a] mix-blend-overlay opacity-40"></div>
    <div class="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-[#111827]"></div>
  </div>

  <div class="relative z-10 text-center px-4 max-w-5xl mx-auto flex flex-col items-center">

    <div class="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-4">
      <img src="/logo_rms_blanco.png" alt="RMS Logo" class="h-24 md:h-36 w-auto drop-shadow-2xl">

      <h1 class="text-7xl md:text-9xl font-black drop-shadow-2xl tracking-widest flex justify-center">
        <span class="brillo-r">r</span>
        <span class="brillo-m">m</span>
        <span class="brillo-s">s</span>
      </h1>
    </div>

    <h2 class="text-3xl md:text-6xl font-extrabold text-white mb-6 drop-shadow-lg tracking-wide uppercase">
      Diseño y Construcción
    </h2>

    <p class="text-xl md:text-2xl text-gray-100 mb-10 font-medium max-w-3xl mx-auto drop-shadow-md">
      Excelencia en obras civiles, eléctricas y telecomunicaciones.
    </p>

    <a href="#contacto" class="bg-[#ffb31c] text-[#1e3a8a] px-10 py-4 rounded-full font-black shadow-2xl hover:bg-white hover:scale-110 transition-all duration-300 inline-block uppercase tracking-wider">
      Empieza tu proyecto
    </a>
  </div>
</section>

<section id="nosotros" class="py-20 bg-[#111827] relative">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

    <div class="text-center mb-16">
      <h2 class="text-4xl md:text-5xl font-extrabold text-white mb-6 uppercase tracking-tight">
        {{ propuestaValor.titulo }}
      </h2>
      <p class="text-gray-300 max-w-4xl mx-auto text-xl leading-relaxed font-light italic">
        "{{ propuestaValor.texto }}"
      </p>
      <div class="w-24 h-1 bg-[#ffb31c] mx-auto mt-8"></div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-10">
      @for (item of datosNosotros; track item.titulo) {
        <div (click)="abrirModalNosotros(item)" class="bg-white p-10 rounded-xl shadow-2xl cursor-pointer group hover:scale-105 transition-all duration-500 relative overflow-hidden border-b-4 border-[#111827] hover:border-[#ffb31c]">
          <div class="absolute inset-0 bg-[#f8fafc] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          <div class="relative z-10 flex flex-col h-full justify-between">
            <div>
              <h3 class="text-3xl font-extrabold text-[#1e3a8a] mb-4 text-center group-hover:text-[#ffb31c] transition-colors tracking-widest uppercase">
                {{ item.titulo }}
              </h3>
              <p class="text-gray-600 text-center text-lg leading-relaxed line-clamp-3">
                {{ item.texto }}
              </p>
            </div>
            <div class="mt-8 text-center">
              <span class="inline-block border-2 border-[#1e3a8a] text-[#1e3a8a] px-6 py-2 rounded-full text-sm font-bold group-hover:bg-[#1e3a8a] group-hover:text-white transition-colors">
                Leer más
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</section>

@if (nosotrosActivo) {
  <div class="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-80 p-4 backdrop-blur-md transition-opacity">

    <div class="bg-white rounded-2xl shadow-2xl w-full max-w-3xl overflow-hidden relative p-12 text-center animate-fade-in-up border-t-8 border-[#ffb31c]">

      <button (click)="cerrarModalNosotros()" class="absolute top-4 right-4 bg-gray-100 rounded-full p-2 text-gray-500 hover:text-white hover:bg-red-500 transition-colors z-20 shadow-sm">
        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <h3 class="text-4xl md:text-5xl font-black text-[#1e3a8a] mb-8 uppercase tracking-widest">
        {{ nosotrosActivo.titulo }}
      </h3>

      <svg class="w-16 h-16 text-[#ffb31c] mx-auto mb-6 opacity-30" fill="currentColor" viewBox="0 0 24 24"><path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/></svg>

      <p class="text-gray-700 text-xl md:text-2xl leading-relaxed italic font-light mb-10">
        "{{ nosotrosActivo.texto }}"
      </p>

      <div class="w-16 h-1 bg-[#1e3a8a] mx-auto rounded-full"></div>

    </div>
  </div>
}

<section id="servicios" class="py-24 bg-white relative">
  <div class="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-gray-50 to-white"></div>

  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
    <div class="text-center mb-20">
      <h2 class="text-4xl md:text-5xl font-black text-[#1e3a8a] uppercase tracking-tight">
        Nuestras Líneas de Negocio
      </h2>
      <div class="w-24 h-2 bg-[#ffb31c] mx-auto mt-4 rounded-full"></div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-12">
      @for (servicio of servicios; track servicio.titulo) {
        <div (click)="abrirModal(servicio)"
             class="group cursor-pointer bg-white rounded-3xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.05)] hover:shadow-[0_30px_60px_rgba(30,58,138,0.15)] transition-all duration-500 transform hover:-translate-y-4">

          <div class="relative h-[450px] overflow-hidden">
            <div class="absolute inset-0 bg-gradient-to-t from-[#1e3a8a] via-transparent to-transparent opacity-0 group-hover:opacity-90 transition-all duration-500 z-10 flex flex-col justify-end p-8">
              <span class="text-white font-bold border-2 border-[#ffb31c] px-6 py-2 rounded-full inline-block w-max transform translate-y-10 group-hover:translate-y-0 transition-transform duration-500">
                EXPLORAR SERVICIO
              </span>
            </div>

            <img [src]="servicio.imagen"
                 [alt]="servicio.titulo"
                 class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110">
          </div>

          <div class="p-8 text-center bg-white border-t border-gray-50">
            <h4 class="text-2xl font-black text-[#1e3a8a] uppercase tracking-wider group-hover:text-[#ffb31c] transition-colors">
              {{ servicio.titulo }}
            </h4>
            <p class="text-gray-500 mt-2 text-sm font-medium">Click para ver detalles técnicos</p>
          </div>
        </div>
      }
    </div>
  </div>
</section>

@if (servicioActivo) {
  <div class="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 p-4 backdrop-blur-md transition-all">
    <div class="bg-white rounded-3xl shadow-2xl w-full max-w-5xl max-h-[90vh] overflow-hidden relative flex flex-col md:flex-row animate-fade-in-up">

      <button (click)="cerrarModal()" class="absolute top-4 right-4 bg-gray-100 rounded-full p-2 text-gray-500 hover:text-white hover:bg-red-500 transition-all z-20">
        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
      </button>

      <div class="w-full md:w-1/3 h-48 md:h-auto relative">
        <img [src]="servicioActivo.imagen" class="w-full h-full object-cover">
        <div class="absolute inset-0 bg-gradient-to-t from-[#1e3a8a]/80 to-transparent md:bg-gradient-to-r"></div>
      </div>

      <div class="w-full md:w-2/3 p-8 md:p-12 overflow-y-auto">
        <h3 class="text-4xl font-black text-[#1e3a8a] mb-2 uppercase">{{ servicioActivo.titulo }}</h3>
        <p class="text-gray-500 mb-8 font-medium italic border-l-4 border-[#ffb31c] pl-4">
          {{ servicioActivo.descripcion }}
        </p>

        <div class="space-y-8">
          @for (cat of servicioActivo.categorias; track cat.nombre) {
            <div>
              <h4 class="text-[#1e3a8a] font-black text-lg mb-4 flex items-center">
                <span class="w-8 h-1 bg-[#ffb31c] mr-3"></span>
                {{ cat.nombre }}
              </h4>
              <ul class="grid grid-cols-1 md:grid-cols-2 gap-3 pl-11">
                @for (punto of cat.puntos; track punto) {
                  <li class="flex items-start text-gray-600 text-sm group">
                    <svg class="w-4 h-4 text-[#ffb31c] mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                    <span class="group-hover:text-[#1e3a8a] transition-colors">{{ punto }}</span>
                  </li>
                }
              </ul>
            </div>
          }
        </div>

        <div class="mt-12 pt-8 border-t border-gray-100">
          <a href="#contacto" (click)="cerrarModal()" class="inline-block bg-[#1e3a8a] text-white px-10 py-4 rounded-xl font-bold hover:bg-[#ffb31c] hover:text-[#1e3a8a] transition-all shadow-lg">
            SOLICITAR COTIZACIÓN
          </a>
        </div>
      </div>
    </div>
  </div>
}

<section id="clientes" class="py-24 bg-white overflow-hidden">
  <div class="max-w-7xl mx-auto px-4 mb-16 text-center">
    <h2 class="text-4xl font-black text-[#1e3a8a] uppercase tracking-tight mb-4">Nuestros Clientes</h2>
    <p class="text-gray-400 uppercase tracking-[0.3em] text-sm italic">Confianza y respaldo en cada proyecto</p>
    <div class="w-20 h-1.5 bg-[#ffb31c] mx-auto mt-6 rounded-full"></div>
  </div>

  <div class="relative w-full overflow-hidden
              before:absolute before:left-0 before:top-0 before:z-10 before:h-full before:w-48 before:bg-gradient-to-r before:from-white before:to-transparent
              after:absolute after:right-0 after:top-0 after:z-10 after:h-full after:w-48 after:bg-gradient-to-l after:from-white after:to-transparent">

    <div class="flex animate-scroll-left mb-12 w-max">
      <div class="flex items-center gap-20 pr-20 flex-shrink-0">
        <img src="/img_logos/arbo.png" alt="Arbo" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/atp.png" alt="ATP" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/caban.png" alt="Caban" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/cma.png" alt="CMA" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/greenyellow.png" alt="GreenYellow" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/ihs.png" alt="IHS" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/linio.png" alt="Linio" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
      </div>
      <div class="flex items-center gap-20 pr-20 flex-shrink-0">
        <img src="/img_logos/arbo.png" alt="Arbo" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/atp.png" alt="ATP" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/caban.png" alt="Caban" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/cma.png" alt="CMA" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/greenyellow.png" alt="GreenYellow" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/ihs.png" alt="IHS" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/linio.png" alt="Linio" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
      </div>
    </div>

    <div class="flex animate-scroll-right w-max">
      <div class="flex items-center gap-20 pr-20 flex-shrink-0">
        <img src="/img_logos/pavimentos.png" alt="Pavimentos" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/phoenix.png" alt="Phoenix" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/qcm.png" alt="QCM" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/sunex.png" alt="Sunex" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/tabasco.png" alt="Tabasco" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/golden.png" alt="Golden" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/arbo.png" alt="Arbo" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
      </div>
      <div class="flex items-center gap-20 pr-20 flex-shrink-0">
        <img src="/img_logos/pavimentos.png" alt="Pavimentos" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/phoenix.png" alt="Phoenix" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/qcm.png" alt="QCM" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/sunex.png" alt="Sunex" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/tabasco.png" alt="Tabasco" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/golden.png" alt="Golden" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
        <img src="/img_logos/arbo.png" alt="Arbo" class="h-16 w-auto grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all mix-blend-multiply">
      </div>
    </div>

  </div>
</section>

<section id="contacto" class="py-24 bg-gray-50 relative">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

    <div class="text-center mb-16">
      <h2 class="text-4xl font-extrabold text-[#1e3a8a] uppercase tracking-wide">Contáctanos</h2>
      <div class="w-24 h-1 bg-[#ffb31c] mx-auto mt-4"></div>
    </div>

    <div class="bg-white rounded-3xl shadow-2xl overflow-hidden flex flex-col lg:flex-row border border-gray-100">

      <div class="lg:w-5/12 bg-[#1e3a8a] text-white p-10 md:p-12 flex flex-col relative overflow-hidden">

        <div class="absolute top-0 right-0 -mr-16 -mt-16 w-48 h-48 rounded-full bg-white opacity-5"></div>
        <div class="absolute bottom-0 left-0 -ml-16 -mb-16 w-32 h-32 rounded-full bg-[#ffb31c] opacity-10"></div>

        <div class="relative z-10">
          <h3 class="text-3xl font-black mb-2 text-white">¿Tienes un proyecto?</h3>
          <p class="text-[#ffb31c] mb-10 font-medium">Escríbenos y nuestro equipo te asesorará.</p>

          <div class="space-y-8 flex-grow">
            <div class="flex items-start group">
              <div class="bg-[#ffb31c] p-3 rounded-full text-[#1e3a8a] mr-5 shadow-lg">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
              </div>
              <div>
                <p class="font-bold text-lg tracking-wide">601 217 3870</p>
                <p class="text-gray-300">Línea de atención</p>
              </div>
            </div>

            <div class="flex items-start group">
              <div class="bg-[#ffb31c] p-3 rounded-full text-[#1e3a8a] mr-5 shadow-lg">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
              </div>
              <div>
                <p class="font-bold text-lg tracking-wide uppercase">Carrera 38B # 2F-06</p>
                <p class="text-gray-300">Bogotá - Colombia</p>
              </div>
            </div>

            <div class="flex items-start group">
              <div class="bg-[#ffb31c] p-3 rounded-full text-[#1e3a8a] mr-5 shadow-lg">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
              </div>
              <div>
                <p class="font-bold text-lg tracking-wide break-all uppercase">contacto@rmscolombia.com</p>
              </div>
            </div>
          </div>

          <div class="mt-12 h-52 w-full rounded-2xl overflow-hidden shadow-inner border-2 border-white/10 relative group">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3976.953531109419!2d-74.0954881!3d4.602372!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f991956e1844b%3A0xc6c768e14b03666!2sCra.%2038b%20%232f-6%2C%20Bogot%C3%A1!5e0!3m2!1ses!2sco!4v1711210000000!5m2!1ses!2sco"
              width="100%"
              height="100%"
              style="border:0;"
              allowfullscreen=""
              loading="lazy">
            </iframe>
          </div>
        </div>
      </div>

      <div class="lg:w-7/12 p-10 md:p-16 flex flex-col justify-center">
        <h3 class="text-2xl font-bold text-[#1e3a8a] mb-8">Envíanos un mensaje</h3>

        <form [formGroup]="contactoForm" (ngSubmit)="enviarMensaje()" class="space-y-6">

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2">Nombre completo *</label>
              <input type="text" formControlName="nombre" placeholder="Ej. Juan Pérez"
                class="w-full bg-gray-50 border p-4 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#ffb31c] transition-all"
                [class.border-red-500]="contactoForm.get('nombre')?.invalid && contactoForm.get('nombre')?.touched"
                [class.border-gray-200]="!(contactoForm.get('nombre')?.invalid && contactoForm.get('nombre')?.touched)">
            </div>
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2">Teléfono</label>
              <input type="text" formControlName="telefono" placeholder="Ej. 300 123 4567" class="w-full bg-gray-50 border border-gray-200 p-4 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#ffb31c] transition-all">
            </div>
          </div>

          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2">Correo electrónico *</label>
            <input type="email" formControlName="email" placeholder="tucorreo@empresa.com"
              class="w-full bg-gray-50 border p-4 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#ffb31c] transition-all"
              [class.border-red-500]="contactoForm.get('email')?.invalid && contactoForm.get('email')?.touched"
              [class.border-gray-200]="!(contactoForm.get('email')?.invalid && contactoForm.get('email')?.touched)">
          </div>

          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2">Mensaje *</label>
            <textarea formControlName="mensaje" rows="4" placeholder="¿En qué te podemos ayudar?"
              class="w-full bg-gray-50 border p-4 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#ffb31c] transition-all resize-none"
              [class.border-red-500]="contactoForm.get('mensaje')?.invalid && contactoForm.get('mensaje')?.touched"
              [class.border-gray-200]="!(contactoForm.get('mensaje')?.invalid && contactoForm.get('mensaje')?.touched)"></textarea>
          </div>

          <div>
            <div class="flex items-center mt-4">
              <input type="checkbox" formControlName="terminos" id="terminos" class="w-5 h-5 text-[#ffb31c] border-gray-300 rounded focus:ring-[#ffb31c] cursor-pointer">
              <label for="terminos" class="ml-3 text-sm text-gray-600 cursor-pointer select-none">
                Acepto el <a href="#" (click)="abrirModalPolitica($event)" class="text-[#1e3a8a] font-bold hover:text-[#ffb31c] transition-colors underline decoration-dotted">tratamiento y política de datos</a>. *
              </label>
            </div>
            @if (contactoForm.get('terminos')?.invalid && contactoForm.get('terminos')?.touched) {
              <p class="text-red-500 text-xs mt-1 ml-8">Debes aceptar los términos para poder enviar el mensaje.</p>
            }
          </div>

          <button type="submit"
            [disabled]="enviando"
            class="w-full bg-[#1e3a8a] text-white font-bold text-lg py-4 rounded-xl hover:bg-[#ffb31c] hover:text-[#1e3a8a] transition-all shadow-lg mt-6 flex justify-center items-center gap-3 group disabled:opacity-70 disabled:cursor-not-allowed">

            @if (enviando) {
              <svg class="animate-spin h-5 w-5 text-current" xmlns="http://www.w3.org/2000/center" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span>Enviando mensaje...</span>
            } @else {
              <span>Enviar Mensaje</span>
              <svg class="w-5 h-5 transform group-hover:translate-x-2 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
              </svg>
            }
          </button>
        </form>

      </div>
    </div>
  </div>
</section>

<footer class="bg-[#1f2937] text-gray-400 py-6 text-center text-sm">
  <p>&copy; 2026 RMS Diseño y Construcción SAS. Todos los derechos reservados.</p>
</footer>

@if (politicaActiva) {
  <div class="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-80 p-4 backdrop-blur-md transition-opacity">
    <div class="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[85vh] overflow-y-auto relative p-8 md:p-12 animate-fade-in-up border-t-8 border-[#1e3a8a]">

      <div class="sticky top-0 text-right z-20 pb-4 bg-white bg-opacity-90">
        <button (click)="cerrarModalPolitica(false)" class="inline-block bg-gray-100 rounded-full p-2 text-gray-500 hover:text-white hover:bg-red-500 transition-colors shadow-sm">
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <h3 class="text-3xl font-black text-[#1e3a8a] mb-8 uppercase tracking-wide border-b-2 border-gray-100 pb-4">
        Autorización para el Tratamiento de Datos Personales
      </h3>

      <div class="text-gray-700 space-y-6 text-sm md:text-base leading-relaxed">
        <p>
          En cumplimiento de lo dispuesto en la <strong>Ley 1581 de 2012</strong> y el Decreto Reglamentario 1377 de 2013, el usuario autoriza a
          <strong>RMS DISEÑO Y CONSTRUCCIÓN SAS</strong>, persona jurídica identificada con <strong>Nit. 901.045.437-7</strong>, con domicilio en Bogotá
          y ubicada en la <strong>Carrera 38 B No. 2F-06</strong>, para recolectar, almacenar, usar, procesar y actualizar los datos suministrados en este formulario.
        </p>

        <h4 class="font-bold text-[#1e3a8a] text-lg mt-6">1. Finalidad y Uso</h4>
        <p>
          La recolección de datos (nombre, correo, teléfono y mensaje) tiene como fin principal mantener una constante comunicación con los clientes,
          atender solicitudes comerciales, enviar información corporativa y gestionar relaciones contractuales o comerciales necesarias para los fines
          empresariales de la compañía.
        </p>

        <h4 class="font-bold text-[#1e3a8a] text-lg mt-6">2. Declaración de Veracidad</h4>
        <p class="italic bg-gray-50 p-4 rounded-xl border-l-4 border-[#ffb31c]">
          "Al aceptar estos términos, declaro que soy el titular de la información reportada, que la he suministrado de forma voluntaria y que es completa, confiable, veraz, exacta y verídica."
        </p>

        <h4 class="font-bold text-[#1e3a8a] text-lg mt-6">3. Derechos y Canales</h4>
        <p>
          Usted tiene derecho a conocer, actualizar y rectificar sus datos personales en cualquier momento. Para ejercer estos derechos o revocar esta autorización,
          puede contactarnos a través del correo electrónico:
          <a href="mailto:contacto@rmscolombia.com" class="text-[#ffb31c] font-bold hover:underline">contacto@rmscolombia.com</a>.
        </p>
      </div>

      <div class="mt-10 text-center border-t-2 border-gray-100 pt-8">
        <button (click)="cerrarModalPolitica(true)" class="bg-[#1e3a8a] text-white px-10 py-3 rounded-xl font-bold hover:bg-[#ffb31c] hover:text-[#1e3a8a] transition-all shadow-md">
          Acepto y entiendo
        </button>
      </div>
    </div>
  </div>
}
